import config from "../../setting";

interface GeocodingResult {
    items: Array<{
        address: {
            [key: string]: any;
        };
    }>;
}

type SuccessCallbackFn = (result: GeocodingResult) => void;

export const GeocodingService = {
    geocode: (addr: string, successCallbackFn: SuccessCallbackFn): void => {
        // Controllo per la presenza della libreria `H` nell'ambiente globale
        const H = (window as any).H;
        if (!H) {
            console.error("HERE Maps library is not loaded.");
            return;
        }

        // Crea un'istanza della piattaforma utilizzando la chiave API
        const platform = new H.service.Platform({
            apikey: config.HMap_AppKey,
        });

        // Ottieni un'istanza del servizio di ricerca
        const service = platform.getSearchService();

        // Chiama il metodo `geocode` con i parametri
        service.geocode(
            { q: addr },
            (result: GeocodingResult) => {
                successCallbackFn(result);
            },
            (e: Error) => console.error(e)
        );
    },

    reverseGeocode: (
        lat: number,
        lng: number,
        successCallbackFn: (result: any) => void
    ): void => {
        // Istanzia una piattaforma e l'oggetto mappa
        const H = (window as any).H;
        const platform = new H.service.Platform({
            apikey: config.HMap_AppKey,
        });

        // Ottieni un'istanza del servizio di ricerca
        const service = platform.getSearchService();

        // Chiama il metodo di reverse geocode con i parametri
        service.reverseGeocode(
            {
                at: `${lat},${lng}`, // Combina latitudine e longitudine
            },
            (result: any) => {
                successCallbackFn(result);
            },
            (e: any) => console.log(e) // Gestione errori
        );
    }

};
